import AbstractDocument from "@/services/firebase/firestore/documents/AbstractDocument";
import {DocumentTypes} from "@/services/firebase/firestore/documents/DocumentTypes";
import {Expose} from "class-transformer";

export default class DocumentPurchase extends AbstractDocument {
  @Expose({name: 'isCanSelectAgent'})
  private _isCanSelectAgent: boolean | null = null;
  @Expose({name: 'isExtWFlowEnabled'})
  private _isExtWFlowEnabled: boolean | null = null;
  @Expose({name: 'defaultAmount'})
  private _defaultAmount: number | null = null;
  @Expose({name: 'defaultExtWFlowAmount'})
  private _defaultExtWFlowAmount: number | null = null;
  @Expose({name: 'minAmountEnabled'})
  private _minAmountEnabled: boolean = false;
  @Expose({name: 'isFeedbackCancelEnabled'})
  private _isFeedbackCancelEnabled: boolean = false;
  @Expose({name: 'minAmount'})
  private _minAmount: number | null = null;
  protected _type: DocumentTypes = DocumentTypes.PURCHASE;

  constructor() {
    super();
  }

  get defaultExtWFlowAmount(): number | null {
    return this._defaultExtWFlowAmount;
  }

  get isExtWFlowEnabled(): boolean | null {
    return this._isExtWFlowEnabled;
  }

  get isCanSelectAgent(): boolean | null {
    return this._isCanSelectAgent;
  }

  get isFeedbackCancelEnabled(): boolean {
    return this._isFeedbackCancelEnabled;
  }

  get defaultAmount() {
    return this._defaultAmount;
  }

  get minAmountEnabled(): boolean {
    return this._minAmountEnabled;
  }

  get minAmount() {
    return this._minAmount;
  }
}
